<template>
  <v-container
    id="dashboard-view"
    fluid
    tag="section"
  >
    <v-row>
      <v-col
        cols="12"
        lg="12"
        md="12"
        xl="7"
      >
        <v-row>
          <v-col cols="12">
            <aging-chart-view
              :items="items"
              @selectedCompanyChanged="onSelectedCompanyChanged"
              @unselectedCompany="onUnselectedCompany"
            />
          </v-col>
        </v-row>
      </v-col>
      <v-col
        class="pt-15 mt-15"
        cols="12"
        lg="12"
        md="12"
        xl="5"
      >
        <v-fade-transition>
          <aging-details-view
            :selected-company="selectedCompany"
            :selected-company-id="selectedCompanyId"
            :selected-company-info="selectedCompanyInfo"
            :company-invoice-items="companyInvoiceItems"
            :company-invoices-color="companyInvoicesColor"
          />
        </v-fade-transition>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { serverUrl } from '../../auth_config.json'
  import { get } from 'vuex-pathify'
  import { updateMenuDrawer, updateScopes } from '../auth/authorization'

  import AgingDetailsView from '../components/aging/AgingDetails.vue'
  import AgingChartView from '../components/aging/AgingChart.vue'

  export default {
    name: 'TeamInvoiceAgingView',
    components: {
      AgingDetailsView,
      AgingChartView,
    },
    data: () => ({
      items: [],
      companyInvoicesColor: 'primary',
      selectedCompany: '',
      selectedCompanyId: null,
      selectedCompanyInfo: [],
      companyInvoiceItems: [],
    }),
    computed: {
      ...get('user', ['dark']),
    },
    async created () {
      this.fetchInvoiceAging().then(data => {
        this.items = data
        updateMenuDrawer()
      })
    },
    methods: {
      onSelectedCompanyChanged (companyInfo) {
        this.companyInvoicesColor = companyInfo.color
        this.companyInvoiceItems = companyInfo.invoiceItems
        this.selectedCompany = companyInfo.company
        this.selectedCompanyId = companyInfo.identifier
        this.selectedCompanyInfo = companyInfo.info
      },
      onUnselectedCompany () {
        this.companyInvoiceItems = []
        this.selectedCompany = ''
        this.selectedCompanyId = null
        this.selectedCompanyInfo = []
        this.companyInvoicesColor = ''
      },
      async fetchInvoiceAging () {
        try {
          const accessToken = await this.$auth.getTokenSilently()
          updateScopes(accessToken)
          console.log('Token: ', accessToken)
          const res = await fetch(`${serverUrl}/api/reports/invoice/aging`, {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          })
          const data = await res.json()
          return data.invoices
        } catch (e) {
          console.log('Error: ', e)
          return []
        }
      },
      getTheme () {
        return this.$vuetify.theme.isDark ? 'dark' : 'light'
      },
    },
  }
</script>

<style scoped>
.v-data-table::v-deep th {
  font-size: 12px !important;
}
.maxArea {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1000;

  width: 99%;
}
tr.v-data-table__selected {
  background-color: #1974d1 !important;
  color: white;
}
</style>
